import "./BackgroundGradient.css";
function BackgroundGradient() {
  return <div className="Bg"></div>;
}

export default BackgroundGradient;
